import type { ComponentProps } from "react";
import { cn } from "@thuthi/ui/lib/utils";

// MUI styled 헬퍼들의 shadcn/Tailwind 대체. export 이름은 원본(styles.js)과 동일하게 유지한다.

export const Paragraph = ({ className = "", ...props }: ComponentProps<"p">) => <p className={cn("py-2", className)} {...props} />;

export const VerticallyCenteredContainer = ({ className = "", ...props }: ComponentProps<"div">) => (
  <div className={cn("text-foreground mx-auto flex w-full max-w-3xl grow flex-col justify-center px-4", className)} {...props} />
);
